// servizi/pubblicita.ts — pubblicità per chi è in Base (SPECIFICA §7).
// Web: un annuncio AdSense nel pannello del risultato (mai sopra la telecamera), solo se nessuno dei due
// giocatori è abbonato (lo decide il server). Il consenso (GDPR) lo raccoglie il messaggio di Google configurato
// in AdSense → Privacy e messaggi, che si carica insieme allo script.
// App Android/iOS: AdMob (annuncio a tutto schermo dopo il risultato, video con premio per la quota): arrivano con
// le build native; finché non ci sono, premioDisponibile() è false e l'app lo dice.
import { eBooleano, eTesto, leggiImpostazione } from "./impostazioni.ts";
import { IMP_APP, PIATTAFORMA } from "../costanti.ts";

export const pubblicitaAttiva = (): boolean => leggiImpostazione(IMP_APP.pubblicitaAttiva, false, eBooleano);

/** Video con premio: solo nelle app (AdMob con verifica sul server). */
export const premioDisponibile = (): boolean => false;

let script: Promise<void> | null = null;
/** Carica lo script di AdSense una volta (solo sul web, solo con il codice cliente impostato). */
export function caricaAdsense(): Promise<boolean> {
  const client = leggiImpostazione(IMP_APP.adsenseClient, "", eTesto);
  if (PIATTAFORMA !== "web" || !/^ca-pub-\d{10,20}$/.test(client)) return Promise.resolve(false);
  script ??= new Promise<void>((ok, no) => {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;
    s.crossOrigin = "anonymous";
    s.onload = () => ok();
    s.onerror = () => {
      script = null;
      no(new Error("AdSense non caricato"));
    };
    document.head.appendChild(s);
  });
  return script.then(
    () => true,
    () => false,
  );
}
